import React from 'react';
import './LightEffects.css';

const LightEffects = ({ variant = 'beams' }) => {
  if (variant === 'beams') {
    return (
      <div className="light-effects-container">
        {/* Diagonal Light Beams - More beams for fuller coverage */}
        <div className="light-beam beam-1"></div>
        <div className="light-beam beam-2"></div>
        <div className="light-beam beam-3"></div>
        <div className="light-beam beam-4"></div>
        <div className="light-beam beam-5"></div>
        <div className="light-beam beam-6"></div>
      </div>
    );
  }

  if (variant === 'lasers') {
    return (
      <div className="light-effects-container">
        {/* Horizontal Laser Lines - More lasers */}
        <div className="laser-line laser-1"></div>
        <div className="laser-line laser-2"></div>
        <div className="laser-line laser-3"></div>
        <div className="laser-line laser-4"></div>
        <div className="laser-line laser-5"></div>
        
        {/* Vertical Laser Lines */}
        <div className="laser-vertical laser-v1"></div>
        <div className="laser-vertical laser-v2"></div>
        <div className="laser-vertical laser-v3"></div>
      </div>
    );
  }

  if (variant === 'strobe') {
    return (
      <div className="light-effects-container">
        {/* Strobe Flash Effects - More strobes */}
        <div className="strobe-flash strobe-1"></div>
        <div className="strobe-flash strobe-2"></div>
        <div className="strobe-flash strobe-3"></div>
      </div>
    );
  }

  if (variant === 'radial') {
    return (
      <div className="light-effects-container">
        {/* Radial Light Bursts - More bursts */}
        <div className="radial-burst burst-1"></div>
        <div className="radial-burst burst-2"></div>
        <div className="radial-burst burst-3"></div>
      </div>
    );
  }

  if (variant === 'spotlight') {
    return (
      <div className="light-effects-container">
        {/* Spotlight Cones - More spotlights */}
        <div className="spotlight spot-1"></div>
        <div className="spotlight spot-2"></div>
        <div className="spotlight spot-3"></div>
        <div className="spotlight spot-4"></div>
      </div>
    );
  }

  if (variant === 'crossing') {
    return (
      <div className="light-effects-container">
        {/* Crossing Beams */}
        <div className="crossing-beam cross-1"></div>
        <div className="crossing-beam cross-2"></div>
      </div>
    );
  }

  if (variant === 'intense') {
    // Combination of multiple effects for maximum visual impact
    return (
      <div className="light-effects-container">
        <div className="light-beam beam-1"></div>
        <div className="light-beam beam-3"></div>
        <div className="laser-line laser-1"></div>
        <div className="laser-line laser-3"></div>
        <div className="radial-burst burst-1"></div>
      </div>
    );
  }

  return null;
};

export default LightEffects;
